<template>
  <div id="Auditors">
    <el-row class="header-row">
      <h3 class="el-page-header">Auditors</h3>
    </el-row>
    <el-form label-position="left" label-width="150px" size="mini">
      <div v-if="!showAddAuditorForm">
        <el-button-group>
          <el-button class="hiaButton" plain round size="mini" @click="toggleAddAuditorForm()" icon="el-icon-plus">Add
            Auditor</el-button>
          <el-button :disabled="disableMergeButton" class="hiaButton" plain round size="mini"
            @click="toggleMergeAuditor()">Merge
            Multiple</el-button>
        </el-button-group>
      </div>
      <el-row v-if="showAddAuditorForm">
        <el-col :lg="8" :md="12">
          <el-form :model="addAuditorForm" ref="addAuditorForm" size="mini" :rules="addAuditorForm.rules"
            label-position="left" label-width="180px" @submit.native.prevent>
            <el-form-item prop="name" label="Name">
              <el-input v-model="addAuditorForm.name" size="mini"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button-group>
                <el-button class="hiaButton" plain round size="mini" type="text"
                  @click="toggleAddAuditorForm()">Cancel</el-button>
                <el-button class="hiaButton" plain round size="mini" @click="addAuditor">Add</el-button>
              </el-button-group>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
      <el-row class="topMargin">
        <el-col :lg="12" :md="18">
          <v-client-table class="hiaTable" v-loading="loading" element-loading-spinner="atom-audit-loader"
            ref="auditorListsGrid" id="auditorListsGrid" :data="auditorList" :columns="auditorColumns"
            :options="auditorOptions" uniqueKey="auditorId">
            <div slot="filter__inactive">
              <input type="checkbox" @change="$refs.auditorListsGrid.setFilter({ inactive: $event.target.checked })">
            </div>
            <template slot="h__email">
              Email <el-tooltip effect="dark"
                content="Linked user email address, users can be linked to auditors via the User Admin menu."
                placement="top">
                <i class="el-icon-info"></i>
              </el-tooltip>
            </template>
            <template slot="selected" slot-scope="props">
              <div class="el-input--mini">
                <input type="checkbox" v-model="props.row.selected" @click="selectRecord(props.row, $event)">
              </div>
            </template>
            <template slot="name" slot-scope="props">
              <div class="el-input--mini">
                <input class="el-input__inner" type="text" v-model="props.row.name" @change="updateAuditor(props.row)">
              </div>
            </template>
            <template slot="inactive" slot-scope="props">
              <input :key="props.row.auditorId" type="checkbox" v-model="props.row.inactive"
                @change="updateAuditor(props.row)">
            </template>
            <template slot="email" slot-scope="props">
              {{props.row.users.length > 0 ? props.row.users.map(x => x.email).join(', ') : null}}
            </template>
            <template slot="delete" slot-scope="props">
              <div style="text-align: center;">
                <i class="el-icon-close delete-button" @click="deleteAuditor(props.row)"></i>
              </div>
            </template>
          </v-client-table>
        </el-col>
      </el-row>
    </el-form>

    <el-dialog title="Merge Auditors" :visible.sync="showMergeAuditor" width="50%">
      <div v-loading="mergeAuditorLoading" element-loading-spinner="atom-audit-loader">
        Select the target auditor record to merge to:
        <table style="margin: 20px 0px 20px 20px;">
          <tr v-for="auditor in auditorList.filter(x => x.selected).sort((a, b) => a.name < b.name ? -1 : 1)"
            :key="auditor.auditorId">
            <td class="auditorOption" :class="{ selected: auditor.auditorId === selectedMergeAuditor.auditorId }"
              @click="selectedMergeAuditor = auditor">{{ auditor.name }} </td>
            <td><i v-if="auditor.auditorId === selectedMergeAuditor.auditorId" class="mdi mdi-check"
                style="color: #63b344; margin-left: 8px;"></i>
            </td>
          </tr>
        </table>
        <span v-if="selectedMergeAuditor.name">Merge all listed auditors to {{ selectedMergeAuditor.name }}</span>
        <div style="margin-bottom: 40px;">
          <div class="pull-right">
            <el-button-group>
              <el-button class="hiaButton" plain round size="mini" type="text"
                @click="toggleMergeAuditor">Cancel</el-button>
              <el-button :disabled="!selectedMergeAuditor.name" class="hiaButton" plain round size="mini"
                @click="doMergeAuditor">Continue
              </el-button>
            </el-button-group>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'
import HiaAuthorization from '@/mixins/hiaAuthorization'
import hiaTable from '@/mixins/hiaTable'

export default {
  name: 'auditorTab',
  mixins: [hiaTable, HiaAuthorization],
  props: [],
  data() {
    return {
      loading: false,
      showMergeAuditor: false,
      mergeAuditorLoading: false,
      selectedMergeAuditor: {},
      localAuditor: [],
      auditorColumns: ['selected', 'name', 'inactive', 'delete'],
      auditorOptions: {
        filterByColumn: true,
        sortable: ['name'],
        orderBy: {
          column: 'name',
          ascending: true
        },
        filterAlgorithm: {
          email(row, query) {
            return row.users.some(x => x.email.toUpperCase().includes(query.toUpperCase()))
          }
        },
        headings: {
          delete: function (h) {
            return ''
          },
          selected: (h) => {
            return h('input', {
              attrs: {
                type: 'checkbox',
                id: 'auditorSelectAllCheckbox',
                disabled: false // this.readOnly()
              },
              on: {
                click: (e) => {
                  this.localselectAll(e.srcElement.checked)
                }
              },
              ref: 'selectAllCheckbox'
            })
          }
        },
        perPage: 10,
        texts: {
          filter: '',
          filterBy: '...'
        },
        highlightMatches: true,
        sortIcon: { is: 'none' }
      },
      showAddAuditorForm: false,
      addAuditorForm: {
        name: '',
        rules: {
          name: [
            { required: true, message: 'Please Input Name', trigger: 'none' }
          ]
        }
      }
    }
  },
  methods: {
    ...mapActions('managedLists/auditors/', ['GET_AUDITORS', 'POST_AUDITOR', 'DELETE_AUDITOR', 'PUT_AUDITOR', 'PUT_MERGE_AUDITOR']),
    ...mapMutations('managedLists/auditors/', ['SET_SELECTED']),
    initialize(route) {
      this.loading = true
      this.GET_AUDITORS().then(response => {
        this.localAuditor = JSON.parse(JSON.stringify(this.auditorList))
        this.loading = false
      })
    },
    localselectAll(checked) {
      let filteredRecords = []

      if (this.$refs.auditorListsGrid) {
        filteredRecords = this.$refs.auditorListsGrid.allFilteredData
      }

      const recs = this.auditorList.filter(x => filteredRecords.some(y => y.auditorId === x.auditorId))
      hiaTable.selectAll(recs, checked)
      this.SET_SELECTED(recs)
    },
    selectRecord(row, e) {
      const checked = e.srcElement.checked
      row.selected = checked
      this.SET_SELECTED([row])
    },
    addAuditor() {
      this.$refs.addAuditorForm.validate(async (valid) => {
        if (valid) {
          try {
            this.loading = true
            const payload = {
              auditor: {
                name: this.addAuditorForm.name
              }
            }
            await this.POST_AUDITOR(payload)
            this.$refs.addAuditorForm.resetFields()
            this.toggleAddAuditorForm()
            this.loading = false
            this.$message({
              message: 'Auditor Added',
              type: 'success'
            })
          } catch (err) {
            this.loading = false
            this.$message({
              message: `Error Adding Auditor: ${err.message}`,
              type: 'error'
            })
          }
        }
      })
    },
    async updateAuditor(auditor) {
      const index = this.auditorList.findIndex(x => x.auditorId === auditor.auditorId)
      this.$set(this.auditorList, index, auditor)

      try {
        this.loading = true
        await this.PUT_AUDITOR(auditor)
        this.loading = false
        this.$message({
          message: 'Auditor Saved',
          type: 'success'
        })
      } catch (err) {
        this.loading = false
        this.$message({
          message: 'Error Editing Auditor',
          type: 'error'
        })
      }
    },
    async deleteAuditor(auditor) {
      await this.$confirm(`Permanently delete ${auditor.name}?`, 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning'
      })

      try {
        this.loading = true
        await this.DELETE_AUDITOR(auditor)
        this.loading = false
        this.$message({
          message: 'Auditor Deleted Successfully',
          type: 'success'
        })
      } catch (err) {
        this.loading = false
        this.$message({
          message: `Error Deleting Auditor: ${err.message}`,
          type: 'error'
        })
      }
    },
    toggleAddAuditorForm() {
      this.showAddAuditorForm = !this.showAddAuditorForm
    },
    toggleMergeAuditor() {
      this.selectedMergeAuditor = {}
      this.showMergeAuditor = !this.showMergeAuditor
    },
    doMergeAuditor() {
      this.$confirm(`Update all existing Review Records for listed Auditor to ${this.selectedMergeAuditor.name}?`, 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {
        this.mergeAuditorLoading = true
        const payload = {
          targetAuditorId: this.selectedMergeAuditor.auditorId,
          auditor: this.auditorList.filter(x => x.selected && x.auditorId !== this.selectedMergeAuditor.auditorId)
        }
        this.PUT_MERGE_AUDITOR(payload).then(response => {
          this.toggleMergeAuditor()
          this.localselectAll(false)

          const table = this.$refs.auditorListsGrid.$el
          const checkboxes = table.querySelectorAll('input[type ="checkbox"]')

          for (let i = 0; i < checkboxes.length; i++) {
            checkboxes[i].checked = false
          }

          this.mergeAuditorLoading = false
        }, error => {
          console.log(error)
          this.mergeAuditorLoading = false
        })
      })
    }
  },
  computed: {
    ...mapState('managedLists/clients/', ['clientList']),
    ...mapState('managedLists/auditors/', ['auditorList', 'auditorListLoading']),
    ...mapState('user/', ['currentTenantGuid']),
    disableMergeButton() {
      return this.auditorList.filter(x => x.selected).length < 2
    }
  },
  watch: {
    currentTenantGuid() {
      this.initialize(this.$route)
    }
  },
  created: function () {
    this.initialize(this.$route)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.auditorOption {
  cursor: pointer;
  padding: 0px 20px 0px 20px;
  color: #337ab7;
}

.auditorOption:hover {
  background: rgba(255, 196, 12, 0.2);
  border-radius: 2px;
}

.selected {
  background: rgba(255, 196, 12, 0.2);
}

.topMargin {
  margin: 10px 0px 0px 0px;
}
</style>
